export const REGISTER_WORKSPACE_STORAGE_KEY = "vocabularium_register_workspace";

export const REGISTER_WORKSPACE_MODES = {
  REGISTER: "register",
  NOTES: "notes",
};

const VALID_MODES = new Set(Object.values(REGISTER_WORKSPACE_MODES));

export function sanitizeRegisterWorkspaceMode(raw) {
  return VALID_MODES.has(raw) ? raw : REGISTER_WORKSPACE_MODES.REGISTER;
}

export function readRegisterWorkspaceMode() {
  try {
    return sanitizeRegisterWorkspaceMode(localStorage.getItem(REGISTER_WORKSPACE_STORAGE_KEY));
  } catch {
    return REGISTER_WORKSPACE_MODES.REGISTER;
  }
}

export function writeRegisterWorkspaceMode(mode) {
  const next = sanitizeRegisterWorkspaceMode(mode);
  try {
    localStorage.setItem(REGISTER_WORKSPACE_STORAGE_KEY, next);
  } catch {
    // quota / mode privé : on ignore
  }
  return next;
}
